<template>
  <div class="custom-paginate-wrapper custom-wrapper">

    <div class="banner">
      <div class="multi-op-wrapper">
        <slot />
      </div>

      <div class="pagination">
        <i class="iconfont icon-shuaxin" @click="$emit('page-change')"></i>
        <el-pagination
          @size-change="onPageSizeChange"
          @current-change="onPageChange"
          :current-page="page"
          :page-sizes="[6, 8, 10, 15, 20, 30, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="count">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { SET_PAGE, SET_PAGE_SIZE } from '@/store/modules/table'

export default {
  name: 'Paginate',
  props: {
    count: {
      type: Number,
      required: true
    },
    defaultPageSize: {
      type: Number,
      required: false
    }
  },
  computed: {
    ...mapState('table', [
      'page',
      'pageSize'
    ])
  },
  methods: {
    ...mapMutations('table', [
      SET_PAGE,
      SET_PAGE_SIZE
    ]),

    onPageChange (page) {
      this.setPage(page)

      this.$emit('page-change')
    },
    onPageSizeChange (pageSize) {
      this.setPage(1)
      this.setPageSize(pageSize)

      this.$emit('page-change')
    }
  },
  mounted () {
    if (this.defaultPageSize > 0) {
      this.setPageSize(this.defaultPageSize)
    } else {
      this.setPageSize(10)
    }
    this.setPage(1)
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/sass/base";

.custom-paginate-wrapper {

  .banner {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .pagination {
      display: flex;
      align-items: center;

      .icon-shuaxin {
        margin-right: .5rem;

        &:hover {
          cursor: pointer;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CustomPaginate.vue